package pl.nickers.match3

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.asList
import org.w3c.files.FileReader
import kotlin.coroutines.resume

actual suspend fun pickBackgroundImage(): String? = suspendCancellableCoroutine { cont ->
    val input = document.createElement("input").unsafeCast<HTMLInputElement>().apply {
        type = "file"
        accept = "image/*"
        style.display = "none"
    }

    input.onchange = {
        val file = input.files?.asList()?.firstOrNull()
        if (file == null) {
            cont.resume(null)
        } else {
            val reader = FileReader()
            reader.onload = {
                // readAsDataURL returns "data:<mime>;base64,<data>" – strip the prefix.
                val dataUrl = reader.result as? String
                val base64 = dataUrl?.substringAfter(",", "")?.takeIf { it.isNotEmpty() }
                cont.resume(base64)
            }
            reader.onerror = { cont.resume(null) }
            reader.readAsDataURL(file)
        }
        Unit
    }

    var focusHandled = false
    window.addEventListener("focus", {
        if (!focusHandled) {
            focusHandled = true
            window.setTimeout({
                if (cont.isActive) cont.resume(null)
            }, 300)
        }
    })

    document.body?.appendChild(input)
    input.click()

    cont.invokeOnCancellation {
        runCatching { document.body?.removeChild(input) }
    }
}
